var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("md-layout", { attrs: { "md-column": "md-column" } }, [
    _vm.videos.length > 0
      ? _c(
          "div",
          [
            _c("div", [
              _c("div", [
                _c("label", [_vm._v(_vm._s(_vm.label))]),
                _c(
                  "div",
                  { staticClass: "info-videos" },
                  [
                    _c("md-icon", {
                      staticClass: "icon-info-videos",
                      attrs: { "md-iconset": "fa fa-info-circle" }
                    }),
                    _c("p", [
                      _vm._v(
                        "If the video has tags or associated series, they will appear as follows:"
                      ),
                      _c("span", { staticClass: "tag sect-series" }, [
                        _vm._v("series")
                      ]),
                      _c("span", { staticClass: "tag" }, [_vm._v("tags")])
                    ])
                  ],
                  1
                )
              ]),
              _vm.containsInvalidItems
                ? _c(
                    "div",
                    { staticClass: "errorMessage" },
                    [
                      _c("md-icon", {
                        staticClass: "md-icon",
                        attrs: { "md-iconset": "fa fa-exclamation-triangle" }
                      }),
                      _c("p", [
                        _vm._v(
                          "Some videos may not appear in the final distribution. Please click on each marked video for more details."
                        )
                      ])
                    ],
                    1
                  )
                : _vm._e()
            ]),
            _c(
              "SlickList",
              {
                staticClass:
                  "videoContainer md-list custom-list md-triple-line",
                attrs: { lockAxis: "y", pressDelay: 100 },
                on: { input: _vm.onSortEnd },
                model: {
                  value: _vm.videos,
                  callback: function($$v) {
                    _vm.videos = $$v
                  },
                  expression: "videos"
                }
              },
              _vm._l(_vm.videos, function(item, index) {
                return _c(
                  "SlickItem",
                  {
                    key: item._id,
                    staticClass: "md-list-item sortable-item noselect",
                    attrs: { index: index }
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "md-list-item-container" },
                      [
                        _c("md-avatar", [
                          _c("img", {
                            attrs: {
                              src: _vm.getVideoPoster(item),
                              alt: item.name
                            }
                          })
                        ]),
                        _c("div", [
                          _c("span", { staticClass: "title" }, [
                            _vm._v(_vm._s(item.name))
                          ]),
                          _c("span", { staticClass: "detail" }, [
                            _vm._v(_vm._s(_vm.formatDuration(item.duration)))
                          ]),
                          _c("span", { staticClass: "detail" }, [
                            _vm._v(_vm._s(item.credit))
                          ]),
                          _c("div", { staticClass: "tagsContainer" }, [
                            item.serie
                              ? _c("span", { staticClass: "tag sect-series" }, [
                                  _vm._v(_vm._s(item.serie.name))
                                ])
                              : _vm._e(),
                            item.tags.length > 0
                              ? _c(
                                  "div",
                                  { staticClass: "tagsContainer" },
                                  _vm._l(item.tags, function(tag) {
                                    return _c("span", { staticClass: "tag" }, [
                                      _vm._v(_vm._s(tag))
                                    ])
                                  }),
                                  0
                                )
                              : _vm._e()
                          ])
                        ]),
                        _c(
                          "div",
                          { staticClass: "btn-container" },
                          [
                            !item.isValid
                              ? _c(
                                  "md-button",
                                  {
                                    staticClass: "md-icon-button",
                                    attrs: { id: "statusBtnWarning" },
                                    on: {
                                      click: function($event) {
                                        return _vm.checkItem(item)
                                      }
                                    }
                                  },
                                  [
                                    _c("md-icon", {
                                      staticClass: "md-icon",
                                      attrs: {
                                        "md-iconset":
                                          "fa fa-exclamation-triangle"
                                      }
                                    })
                                  ],
                                  1
                                )
                              : _c("md-button", {
                                  staticClass: "md-icon-button",
                                  attrs: { id: "statusBtnOk" }
                                }),
                            _c(
                              "md-button",
                              {
                                staticClass: "md-icon-button md-raised",
                                attrs: { id: "btnInfo" },
                                nativeOn: {
                                  mouseover: function($event) {
                                    return _vm.showInfo(index, true)
                                  },
                                  mouseleave: function($event) {
                                    return _vm.showInfo(index, false)
                                  }
                                }
                              },
                              [
                                _c("md-icon", {
                                  staticClass: "md-icon",
                                  attrs: { "md-iconset": "fa fa-info-circle" }
                                })
                              ],
                              1
                            ),
                            _c(
                              "md-button",
                              {
                                staticClass:
                                  "md-icon-button md-warn md-list-action",
                                on: {
                                  click: function($event) {
                                    return _vm.removeItem(index)
                                  }
                                }
                              },
                              [
                                _c("md-icon", {
                                  staticClass: "md-icon",
                                  attrs: { "md-iconset": "fa fa-trash-alt" }
                                })
                              ],
                              1
                            ),
                            _vm.isShowInfo === index
                              ? _c(
                                  "div",
                                  { staticClass: "info-video" },
                                  [
                                    item.licenses.length > 0
                                      ? _c("p", { staticClass: "text-item" }, [
                                          _c("strong", [_vm._v("License: ")])
                                        ])
                                      : _vm._e(),
                                    _vm._l(item.licenses, function(
                                      license,
                                      index
                                    ) {
                                      return _c("p", [
                                        _vm._v(
                                          _vm._s(license.name) +
                                            " " +
                                            _vm._s(
                                              index !== item.licenses.length - 1
                                                ? ", "
                                                : ""
                                            )
                                        )
                                      ])
                                    }),
                                    _c("p"),
                                    item.categories
                                      ? _c("p", { staticClass: "text-item" }, [
                                          _c("strong", [_vm._v("Categories: ")])
                                        ])
                                      : _vm._e(),
                                    _vm._l(item.categories, function(
                                      category,
                                      index
                                    ) {
                                      return _c("p", [
                                        _vm._v(
                                          _vm._s(category) +
                                            " " +
                                            _vm._s(
                                              index !==
                                                item.categories.length - 1
                                                ? ", "
                                                : ""
                                            )
                                        )
                                      ])
                                    }),
                                    _c("p")
                                  ],
                                  2
                                )
                              : _vm._e()
                          ],
                          1
                        ),
                        _c("md-divider")
                      ],
                      1
                    )
                  ]
                )
              }),
              1
            )
          ],
          1
        )
      : _c(
          "div",
          { attrs: { id: "no-results" } },
          [
            _c("md-icon", {
              staticClass: "md-accent",
              attrs: { "md-iconset": "fa fa-exclamation-circle" }
            }),
            _vm._v("No items to show")
          ],
          1
        )
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-dd05856a", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dd05856a","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug&optionsId=0!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/shared-components/distribution/DistributionArrangedList.vue
// module id = 751
// module chunks = 0